import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F2BD0434-FE75-43EB-BA3A-AFCE445DE335
 * name floor-lamp-torchiere-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-torchiere-outline.svg
 * tags
 * - Home Automation 
 */
export const FloorLampTorchiereOutlineIcon = createSvgIcon(<><path d="M14 4L12.7 7H11.3L10 4H14M17 2H7L10 9H14L17 2M13 20H16V22H8V20H11V10H13V20Z" /></>, 'FloorLampTorchiereOutlineIcon');
export default FloorLampTorchiereOutlineIcon